var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.1906 9.92678L12.204 4.93345C5.49562 1.57345 2.74228 4.32678 6.10228 11.0351L7.11728 13.0651C7.40895 13.6601 7.40895 14.3484 7.11728 14.9434L6.10228 16.9618C2.74228 23.6701 5.48395 26.4234 12.204 23.0634L22.1906 18.0701C26.6706 15.8301 26.6706 12.1668 22.1906 9.92678ZM18.4223 14.8734H12.1223C11.6439 14.8734 11.2473 14.4768 11.2473 13.9984C11.2473 13.5201 11.6439 13.1234 12.1223 13.1234H18.4223C18.9006 13.1234 19.2973 13.5201 19.2973 13.9984C19.2973 14.4768 18.9006 14.8734 18.4223 14.8734Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.652fbec68909333912586609c68d16fe.svg";
export { ForwardRef as ReactComponent };